import React from "react";
import { Grid, Paper, Text, Title } from "@mantine/core";
import { PDFPage } from "./PDFPage";
import useReportStore from "../../../store/useReportStore";

const COLORS = ["#05D8D2", "#A64DD7", "#6F40E2", "#3A8BD9"];

export const DataAnalysisSkillsPDF = () => {
  const { report } = useReportStore();
  const roadmapSkills = report?.skills_to_master_switch_role?.mark_down
  ? report?.skills_to_master_switch_role
  : report?.skills_to_master_higher_role?.mark_down
  ? report.skills_to_master_higher_role
  : null;

  return (
    <PDFPage padding>
      <Title size={48} mb={16}>
        {roadmapSkills?.mark_down
          ? roadmapSkills?.mark_down.replace("##", "")
          : ""}
      </Title>
      <Text mb={48} size="28px" lh="42px" c="dimmed">
        {roadmapSkills?.explanation ? roadmapSkills?.explanation : ""}
      </Text>
      <Grid gutter={32}>
        {roadmapSkills?.data.map((item, index) => (
          <Grid.Col key={index} span={6}>
            <Paper
              radius="36px"
              p="48px"
              bg={COLORS[index % COLORS.length]}
              maw={578}
            >
              <Title size={40} mb={32} c="#fff" lh="55px">
                {item.title}
              </Title>
              <Text c="#fff" size="28px" lh="42px">
                {item.description}{" "}
              </Text>
            </Paper>
          </Grid.Col>
        ))}
      </Grid>
    </PDFPage>
  );
};
